import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Axios from "axios";

import { useStyles } from "../../../../Components/CSS/FilterStyle.css";
import { url } from "../../../../Config/Config";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";

class ClassAcademyForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      classList: [],
      facultyError: "",
      groupError: "",
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    try {
      const classResponse = await Axios.get(`${url}/api/schoolclass`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (classResponse.data.classes.length !== 0) {
        this.setState({
          classList: classResponse.data.classes,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getData();
      }
    }
  };

  filterFaculty = () => {
    const facultyFilter = this.state.classList
      .filter((filter) => filter.className === this.props.data.class)
      .map((filter) => filter.faculty);
    let status = facultyFilter.map((filter) => {
      return filter === null || filter === undefined ? false : true;
    });
    if (status.includes(false)) {
      return false;
    } else {
      return true;
    }
  };

  checkError = () => {
    let facultyError = "";
    let groupError = "";
    let status = this.filterFaculty();

    if (status) {
      if (!this.props.data.faculty) {
        facultyError = "Please Enter Faculty";
      }
    }

    if (this.props.data.faculty) {
      if (!this.props.data.group) {
        groupError = "Please select group ";
      }
    }

    if (facultyError || groupError) {
      this.setState({
        facultyError,
        groupError,
      });
      return true;
    } else {
      this.setState({
        facultyError: "",
        groupError: "",
      });
      return false;
    }
  };

  handleInitalSubmit = (e, subject) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      this.props.handleSubmit(e, subject);
    }
  };

  render() {
    const { classes, data, handleChange, handleClassChange } = this.props;
    const classFilter = this.state.classList.map((data) => data.className);
    const facultyFilter = this.state.classList
      .filter((filter) => filter.className === data.class)
      .map((data) => (data.faculty ? data.faculty : ""));
    const groupFilter = this.state.classList
      .filter(
        (filter) =>
          filter.className === data.class && filter.faculty === data.faculty
      )
      .map((filter) => (filter.group ? filter.group : ""));
    const subjectFilter = this.state.classList
      .filter((filter) =>
        data.faculty && data.group
          ? filter.className === data.class &&
            filter.faculty === data.faculty &&
            filter.group === data.group
          : filter.className === data.class
      )
      .map((filter) => filter.subjects);
    return (
      <form onSubmit={(e) => this.handleInitalSubmit(e, subjectFilter[0])}>
        <div className={classes.fieldStyle}>
          <TextField
            name="class"
            select
            required
            fullWidth
            label="Class"
            variant="outlined"
            margin="normal"
            style={{ marginRight: 20 }}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.class}
            onChange={handleClassChange}
          >
            <option value="">Select Any One</option>
            {classFilter
              .filter((value, index) => classFilter.indexOf(value) === index)
              .map((classData, index) => (
                <option key={index} value={classData}>
                  {classData}
                </option>
              ))}
          </TextField>
          <TextField
            name="faculty"
            select
            fullWidth
            label="Faculty"
            variant="outlined"
            margin="normal"
            style={{ marginRight: 20 }}
            error={this.state.facultyError ? true : false}
            helperText={
              this.state.facultyError
                ? this.state.facultyError
                : data.faculty
                ? null
                : facultyFilter.length === 0
                ? "Please Select Class to get faculties"
                : "No any faculty for this class"
            }
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.faculty}
            onChange={handleChange}
          >
            <option value="">Select Any One</option>
            {facultyFilter
              .filter((value, index) => facultyFilter.indexOf(value) === index)
              .map((classData, index) => (
                <option key={index} value={classData}>
                  {classData}
                </option>
              ))}
          </TextField>

          <TextField
            name="group"
            select
            fullWidth
            label="Group"
            variant="outlined"
            margin="normal"
            style={{ marginRight: 20 }}
            error={this.state.groupError ? true : false}
            helperText={
              this.state.groupError
                ? this.state.groupError
                : data.group
                ? null
                : groupFilter.length === 0
                ? "Please Select Faculty to get groups"
                : "No any group for this group"
            }
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.group}
            onChange={handleChange}
          >
            <option value="">Select Any One</option>
            {groupFilter
              .filter((value, index) => groupFilter.indexOf(value) === index)
              .map((group, index) => (
                <option key={index} value={group}>
                  {group}
                </option>
              ))}
          </TextField>
        </div>
        <br />
        {this.props.buttonLabel && (
          <Button
            type="submit"
            variant="outlined"
            color="primary"
            className={classes.buttonStyle}
          >
            {this.props.buttonLabel}
          </Button>
        )}
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    isAdmin: state.AdminReducer.isAdmin,
    role: state.AdminReducer.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(ClassAcademyForm));
